import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`

export const FooterContactItem = styled.div`
  display: flex;
  margin-left: ${Spacing.S12};
`

export const Info = styled.div`
  display: flex;
`
